import { useEffect, useMemo } from 'react'

import { DSAlert, DSCircularLoading, DSPagination } from '@vr/ds-react'

import { CollectUnits } from '@/compositions/collect-units'
import { useCollectContext } from '@/contexts/collect.context'
import { formatDateToBR } from '@/utils/format-date-to-br'

const PAGE_SIZE = 10

export const CollectList = () => {
  const {
    tableData,
    isLoading,
    results,
    limit,
    setPage,
    handleLimitChange
  } = useCollectContext()

  useEffect(() => {
    handleLimitChange(PAGE_SIZE)
  }, [])

  const mappedData = useMemo(() => {
    return tableData.map(item => {
      return {
        ...item,
        operadora: item.nome,
        dataLiberacao: formatDateToBR(new Date(item.dataLiberacao))
      }
    })
  }, [tableData])

  return (
    <>
      {isLoading && <DSCircularLoading isLoading shouldBlur={true} />}

      {!isLoading && mappedData.length === 0 && (
        <DSAlert
          type='info'
          title={'Sem resultados para os filtros selecionados'}
          css={{ marginTop: '$sm16' }}
          hiddenBtnClose
        >
          Tente ajustar os filtros para exibir os resultados desejados
        </DSAlert>
      )}

      {mappedData.map(item => (
        <CollectUnits key={item.id} data={item} />
      ))}

      <DSPagination
        total={results}
        maxPerPage={limit}
        handleChange={(newPage: number) => setPage(newPage)}
        nextPreview
        siblingCount={1}
      />
    </>
  )
}
